export const images = {
  terrace: 'https://cdn.magicpatterns.com/uploads/p8TsEvHrSX5YTwS4NFpG6o/unnamed.webp',
  facade: 'https://cdn.magicpatterns.com/uploads/dwKhs5WVgTHisZ6QK7N6Cp/unnamed_(3).webp',
  salon: 'https://cdn.magicpatterns.com/uploads/cfUvAb6DfXDef3PJLoXrRh/unnamed_(5).webp',
  pork: 'https://cdn.magicpatterns.com/uploads/iAihdEaxsY7bXbG6xx8UsJ/unnamed_(1).webp',
  vitello: 'https://cdn.magicpatterns.com/uploads/65EKXtBR9rsWs4u9u2Ckxn/unnamed_(2).webp',
  beet: 'https://cdn.magicpatterns.com/uploads/mReti52Awi9MtZMhyC9udg/unnamed_(4).webp',
};

export const contact = {
  phone: '05 58 07 34 11',
  phoneHref: 'tel:+33558073411',
  email: 'contact@lebistrotjeanot.fr',
  city: 'Pontenx-les-Forges',
  region: '40200 · Landes',
  mapHref: 'https://www.google.com/maps/search/?api=1&query=Le+Bistrot+Jeanot+Pontenx-les-Forges',
  facebook: 'https://www.facebook.com/',
  instagram: 'https://www.instagram.com/',
};

export const hours = [
  { days: 'Lundi', time: 'Fermé' },
  { days: 'Mardi – Jeudi', time: '12h – 14h' },
  { days: 'Vendredi – Samedi', time: '12h – 14h · 19h – 22h' },
  { days: 'Dimanche', time: '12h – 14h30' },
];

export const navLinks = [
  { label: 'La maison', href: '#maison' },
  { label: 'La carte', href: '#carte' },
  { label: 'Le salon', href: '#salon' },
  { label: 'Nous trouver', href: '#infos' },
];
